module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQIAAAAKBAMAAACtRU26AAAAElBMVEUAAAD/vRz/vBv/vRz/vhz/vBzmi5Y1AAAABXRSTlMA6xN/dVW9PSsAAAAlSURBVDjLYxh44Cg4sMCBwTR0YIHBqAtGXTDqAqgLmJQGFjAAAOsxQ9ARDPgyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main3-line.png
// module id = 8p3I
// module chunks = 7